var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TitleWithRow", { attrs: { title: "Dados de uso do solo" } }),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("InputRadio", {
            attrs: {
              nomeAba: _vm.nomeAba,
              widthColumn: 24,
              label: "Possui reserva legal?",
              obrigatorio: true,
              options: _vm.opcoesSimNaoNaoSei
            },
            model: {
              value: _vm.usoSolo.possuiReservaLegal,
              callback: function($$v) {
                _vm.$set(_vm.usoSolo, "possuiReservaLegal", $$v)
              },
              expression: "usoSolo.possuiReservaLegal"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("InputCheck", {
            attrs: {
              nomeAba: _vm.nomeAba,
              label: "Destinação do imóvel",
              obrigatorio: true,
              options: _vm.opcoesDestinacaoUsoImovel,
              rulesInput: "required"
            },
            model: {
              value: _vm.usoSolo.destinacoesImovel,
              callback: function($$v) {
                _vm.$set(_vm.usoSolo, "destinacoesImovel", $$v)
              },
              expression: "usoSolo.destinacoesImovel"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("InputSelect", {
            attrs: {
              nomeAba: _vm.nomeAba,
              label: "O agricultor é fornecedor de alguma empresa?",
              obrigatorio: true,
              opcoes: _vm.opcoesSimNao,
              multiSelect: false,
              widthColumn: 12,
              rulesInput: "required"
            },
            model: {
              value: _vm.usoSolo.hasFornecedoras,
              callback: function($$v) {
                _vm.$set(_vm.usoSolo, "hasFornecedoras", $$v)
              },
              expression: "usoSolo.hasFornecedoras"
            }
          }),
          _vm._v(" "),
          _vm.containsOption(
            _vm.usoSolo.hasFornecedoras,
            true,
            "empresasFornecedoras"
          )
            ? _c("InputSelect", {
                attrs: {
                  nomeAba: _vm.nomeAba,
                  label: "Quais empresas fornece?",
                  obrigatorio: true,
                  rulesInput: "required",
                  opcoes: _vm.empresasList,
                  multiSelect: true,
                  widthColumn: 6
                },
                on: { input: _vm.setEmpresasFornecedoras },
                model: {
                  value: _vm.empresasFornecedorasSelecionadas,
                  callback: function($$v) {
                    _vm.empresasFornecedorasSelecionadas = $$v
                  },
                  expression: "empresasFornecedorasSelecionadas"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.containsOption(
            _vm.empresasFornecedorasSelecionadas,
            "OUTRA",
            "outrasEmpresasFornecedoras"
          )
            ? _c(
                "div",
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required",
                      name: _vm.nomeAba + "/Descreva qual"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c("Label", {
                                    attrs: {
                                      label: "Descreva qual",
                                      obrigatorio: true
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    class: { "input erro": errors.length },
                                    attrs: {
                                      name: "Descreva qual",
                                      placeholder: "Descreva a outra opção..."
                                    },
                                    model: {
                                      value:
                                        _vm.usoSolo.outrasEmpresasFornecedoras,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.usoSolo,
                                          "outrasEmpresasFornecedoras",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "usoSolo.outrasEmpresasFornecedoras"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(" " + _vm._s(errors[0]))
                                  ])
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3027640806
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("Label", {
                attrs: { label: "Qual a destinação da produção?" }
              }),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  name: "Qual a destinação da produção?",
                  placeholdes: "Digite a destinação da produção"
                },
                model: {
                  value: _vm.usoSolo.destinacaoProducao,
                  callback: function($$v) {
                    _vm.$set(_vm.usoSolo, "destinacaoProducao", $$v)
                  },
                  expression: "usoSolo.destinacaoProducao"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f47b478", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f47b478","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/modulos/cadastro/formulario-cadastro/uso-solo/uso-solo.vue
// module id = null
// module chunks = 